import React, { useEffect, useRef, useMemo } from "react";
import JsBarcode from "jsbarcode";

const PortraitBarcodeLabel = ({ data }) => {
  const barcodeRefs = useRef([]);

  // Barcode settings for portrait labels (60mm wide × 40mm tall)
  const barcodeOptions = useMemo(
    () => ({
      format: "CODE128",
      lineColor: "#000000",
      width: 1.7, // Optimal thickness for scanning
      height: 35, // Reduced height for portrait layout
      displayValue: true,
      fontSize: 10,
      margin: 5,
      fontOptions: "bold",
    }),
    []
  );

  const expandedVariants = useMemo(
    () =>
      data.flatMap((product) =>
        product.variants.flatMap((variant) =>
          Array.from({ length: variant.quantity }, (_, i) => ({
            ...variant,
            product_title: product.product_title,
            uniqueKey: `${variant.id}-${i}`,
          }))
        )
      ),
    [data]
  );

  useEffect(() => {
    barcodeRefs.current.forEach((ref, index) => {
      if (ref && expandedVariants[index]?.laam_barcode) {
        JsBarcode(ref, expandedVariants[index].laam_barcode, barcodeOptions);
      }
    });
  }, [expandedVariants, barcodeOptions]);

  return (
    <div
      className="portrait-labels"
      style={{
        width: "64mm",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>{`
        @page {
          size: 64mm 45mm;
          margin: 0;
        }
        body {
          margin: 0 !important;
          padding: 0 !important;
        
        }
        .label {
          width: 60mm;
          height: 41mm;
          display: flex;
          flex-direction: column;
          padding: 2mm;
          position: relative;
          box-sizing: border-box;
         border-radius: 15px;
        border: 1px dashed blue; 
          margin-bottom: 2mm;
          margin-left: 2mm;
          overflow: hidden;
          page-break-after: always;
         
        }
        
        .text-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
         
        }
        .product-name {
          font-size: 9pt;
          font-weight: bold;
          margin-bottom: 1mm;
          line-height: 1;
          word-break: break-word;
        }
        .variant-details {
          font-size: 9pt;
         
        }
        .variant-title {
          font-size: 10pt;
          font-weight: bold;
          margin-bottom: 0mm;
        }
        .barcode-container {
          width: 100%;
          height: 20mm;
          display: flex;
          justify-content: center;
          align-items: center;
          
        }
        .footer-container {
          position: absolute; /* Changed to absolute */
      top: 36.7mm; 
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      width: 100%;
        
        }
        .web-small {
          font-size: 6pt;
          font-weight: bold;
          text-align: center;
        }
        .sequence-number {
          position: absolute;
          right: 2mm;
          font-size: 5pt;
          font-weight: bold;
        }
      `}</style>

      {expandedVariants.map((variant, index) => (
        <div key={variant.uniqueKey} className="label ">
          <div className="text-content">
            <div className="product-name ">{variant.product_title}</div>
            <div className="variant-title ">Size {variant.variant_title}</div>
            <div className="variant-details ">{variant.laam_sku}</div>
          </div>
          <div className="barcode-container">
            <svg
              ref={(el) => (barcodeRefs.current[index] = el)}
              aria-label={`Barcode for ${variant.laam_sku}`}
            />
          </div>

          <div className="footer-container">
            <p className="web-small">www.velvourshop.com/ x Laam</p>
            <span className="sequence-number">{index + 1}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PortraitBarcodeLabel;
